<div class="container pt-3">
  <h3 class="text-center">{{ isNew ? 'Add New Short Line' : profile ? profile.reportingMark + ' - ' + profile.roadName : 'Short Line' }}</h3>
  <mat-divider></mat-divider>
  <form [formGroup]="summary" class="pt-3 row">
    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <mat-form-field appearance="outline" color="accent" class="w-100">
        <mat-label ngRequired>Short Line Name</mat-label>
        <input matInput ngSpecialCharacter ngCharsOnly ngTrim [regex]="abbrPattern" formControlName="reportingMark" aria-label="Short Line Name"
               maxlength="50"
               class="text-uppercase">
        <mat-hint *ngIf="loadingSearch" class="w-100">
          Searching...
          <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
        </mat-hint>
        <mat-error *ngIf="summary.get('reportingMark')?.hasError('required') && !summary.get('reportingMark')?.hasError('duplicated')">
          This field is required
        </mat-error>
        <mat-error *ngIf="summary.get('reportingMark')?.hasError('duplicated') && !summary.get('reportingMark')?.hasError('required')">
          Short Line Already Exist
        </mat-error>
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline" color="accent" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" *ngIf="isNew">
      <mat-label ngRequired>Short Line Full Name</mat-label>
      <input matInput ngSpecialCharacter [regex]="pattern" ngTrim formControlName="roadName" aria-label="Short Line Full Name"
             maxlength="50">
      <mat-error *ngIf="!summary.get('roadName')?.valid">
        This field is required
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <mat-label>Primary Contact Name</mat-label>
      <input matInput formControlName="primaryContact" aria-label="Primary Contact" ngSpecialCharacter [regex]="pattern" ngTrim maxlength="50">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <mat-label>Primary Contact Title</mat-label>
      <input matInput formControlName="title" aria-label="Title" ngSpecialCharacter [regex]="pattern" ngTrim maxlength="50">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <mat-label>Primary Contact Phone</mat-label>
      <input matInput formControlName="phone" ngPhoneMask placeholder="(###)###-####" maxlength="13" aria-label="Phone">
      <mat-error *ngIf="!summary.get('phone')?.valid">
        Please provide a valid phone number
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <mat-label>Primary Contact Fax</mat-label>
      <input matInput formControlName="fax" ngPhoneMask placeholder="(###)###-####" maxlength="13" aria-label="Fax">
      <mat-error *ngIf="!summary.get('fax')?.valid">
        Please provide a valid fax number
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <mat-label>Primary Contact Email</mat-label>
      <input matInput ngTrim formControlName="email" aria-label="Email" maxlength="50">
      <mat-error *ngIf="!summary.get('email')?.valid">
        Please provide a valid email
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-12">
      <mat-label>Primary Contact Address Line</mat-label>
      <textarea matInput ngSpecialCharacter [regex]="pattern" ngTrim cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="4" maxlength="100"
                formControlName="addressLine" aria-label="Address Line">
      </textarea>
    </mat-form-field>
    <ns-autocomplete class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" ngCharsOnly
                     (selected)="autocompleteSelected('addressCity', 'addressState')" [data]="states"
                     [disabled]="true"
                     [formCtrl]="summary.controls.addressState" ngCharsOnly label="State" ngSpecialCharacter type="simple" [isRequired]="false">
    </ns-autocomplete>
    <ns-autocomplete class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" [data]="cities" [filter]="false" [formCtrl]="summary.controls.addressCity"
                     label="City"
                     maxLength="50"
                     ngSpecialCharacter [regex]="pattern" type="simple" [isLoading]="loadingCities"
                     [isRequired]="summary.controls.addressState.valid && summary.controls.addressState.value"
                     [disabled]="!(summary.controls.addressState.enabled && summary.controls.addressState.value)">
    </ns-autocomplete>
    <mat-form-field appearance="outline" color="accent" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <mat-label>Zip</mat-label>
      <input matInput formControlName="addressZip" ngNumbersOnly ngTrim maxlength="5" minlength="5" aria-label="Zip"
             [required]="summary.controls.addressState.valid && summary.controls.addressCity.valid">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-12">
      <mat-label>Primary Contact Web Address</mat-label>
      <input matInput ngTrim oninput="this.value = this.value.toLowerCase()"
             formControlName="webAddress" aria-label="Web Address" placeholder="Example: https://webaddress.com" maxlength="50">
      <mat-error *ngIf="!summary.get('webAddress')?.valid">
        Please type a valid web address
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
      <mat-label>Customer Number</mat-label>
      <input matInput formControlName="companyEid" aria-label="Customer Number" ngNumbersOnly ngTrim maxlength="10" minlength="6">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
      <mat-label>Customer Service Phone</mat-label>
      <input matInput ngPhoneMask placeholder="(###)###-####" maxlength="13" formControlName="customerServicePhone"
             aria-label="Customer Service Phone">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
      <mat-label>Customer Service Hours</mat-label>
      <input matInput ngSpecialCharacter [regex]="pattern" ngTrim formControlName="customerServiceHours" aria-label="Customer Service Hours">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
      <mat-label>Sales Representative</mat-label>
      <input matInput ngSpecialCharacter [regex]="pattern" ngTrim formControlName="salesRepresentative" aria-label="Sales Representative">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-12">
      <mat-label>History</mat-label>
      <textarea matInput ngSpecialCharacter [regex]="pattern" ngTrim cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="4"
                formControlName="history" aria-label="History">
      </textarea>
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
      <mat-label>Equipment Info</mat-label>
      <input matInput ngSpecialCharacter [regex]="pattern" ngTrim formControlName="equipmentInfo" aria-label="Equipment Info" maxlength="50">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
      <mat-label>Paper Barriers</mat-label>
      <input matInput ngSpecialCharacter [regex]="pattern" ngTrim formControlName="paperBarriers" aria-label="Paper Barriers" maxlength="225">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-12">
      <mat-label>NS Comments</mat-label>
      <textarea matInput ngSpecialCharacter [regex]="pattern" cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="4"
                formControlName="nsComments" aria-label="NS Comments">
      </textarea>
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <mat-label>NS Manager</mat-label>
      <input matInput ngSpecialCharacter [regex]="pattern" ngTrim formControlName="nsManager" aria-label="NS Manager" maxlength="50">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <mat-label>Accounting Status</mat-label>
      <input matInput ngSpecialCharacter [regex]="pattern" ngTrim formControlName="accountingStatus" aria-label="Accounting Status" maxlength="50">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <mat-label>Include</mat-label>
      <input matInput ngSpecialCharacter [regex]="pattern" ngTrim formControlName="includeArea" aria-label="include Area" maxlength="50">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <mat-label>Sales Office</mat-label>
      <input matInput ngSpecialCharacter [regex]="pattern" ngTrim formControlName="salesOffice" aria-label="Sales Office" maxlength="50">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <mat-label>Acct. Comments</mat-label>
      <input matInput ngSpecialCharacter [regex]="pattern" ngTrim formControlName="accountComments" aria-label="Acct. Comments" maxlength="4000">
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <mat-label>Fake Acct. Status</mat-label>
      <input matInput ngSpecialCharacter [regex]="pattern" ngTrim formControlName="fakeAccountingStatus" aria-label="Face Acct. Status"
             maxlength="50">
    </mat-form-field>
  </form>
  <div class="d-flex justify-content-end mb-3">
    <ng-container *ngIf="isNew || isEdit">
      <button mat-stroked-button color="warn" aria-label="Cancel Button" class="mr-2" (click)="cancel()" *ngIf="!isNew">Cancel</button>
      <div matTooltip="Please enter all required criteria in order to save." [matTooltipDisabled]="summary.valid">
        <button mat-flat-button color="accent" aria-label="Save/Update Button" class="mr-2" [disabled]="!summary.valid"
                (click)="save()">{{ isEdit ? 'Save' : isNew ? 'Submit' : '' }}</button>
      </div>
    </ng-container>
    <div *ngIf="!!profile && !isNew && !isEdit && ( isAdmin || canEdit )">
      <button mat-flat-button color="accent" aria-label="Edit Button" (click)="edit()">Edit</button>
      <mat-progress-bar mode="indeterminate" color="accent" *ngIf="loading"></mat-progress-bar>
    </div>
  </div>
</div>
